import { Declaration } from 'store/declarations/declaration';
import { User } from 'store/session/user';
import getColumns, { ActionEvents } from '../DeclarationColumns';

// The standard columns have no barcode or group actions, so those handlers are left out.
export const pickStandardActions = (actions: ActionEvents): ActionEvents => ({
    onDuplicate: actions.onDuplicate,
    onArchive: actions.onArchive,
    onUnarchive: actions.onUnarchive,
    onPrint: actions.onPrint,
    onDelete: actions.onDelete,
    filterDataColumns: actions.filterDataColumns,
    onCoreTemplateToggle: actions.onCoreTemplateToggle,
});

// Used wherever the table can hold a mix of declarations (e.g. the job overview), so the MRN and
// DUCR share one column: each row shows whichever identifies it.
const getStandardColumns = (actions: ActionEvents, user: User | undefined, declarations?: Declaration[]) =>
    getColumns(pickStandardActions(actions), user, declarations, { ducr: 'combined' });

export default getStandardColumns;
